import { useState, forwardRef, useRef, useEffect, useCallback } from "react";
import api from "api/api";

//Props Validations
import PropTypes from "prop-types";

import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
// import Tooltip from "@mui/material/Tooltip";

import Select from "react-select";
import makeAnimated from "react-select/animated";

// import mui icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import SendIcon from "@mui/icons-material/Send";

import CustomOption from "../driverAnalysis/shareDialog/CustomOption";
import CustomMultiValueLabel from "../driverAnalysis/shareDialog/CustomMultiValueLabel";
import CustomMultiValueRemove from "../driverAnalysis//shareDialog/CustomMultiValueRemove";

import { getNameLetter, stringToColor } from "../../utils/driverAnalysisUtils";

import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

const animatedComponents = makeAnimated();

const DIALOG_HEIGHT = 170;

const manageAccessContainerStyle = {
    border: "1px solid rgb(167 172 179)",
    borderRadius: "10px",
    padding: "10px",
    minHeight: "300px",
    maxHeight: "300px",
    margin: "0px 25px 30px",
};
const Transition = forwardRef(function Transition(props, ref) {
    return (
        <Slide
            direction="up"
            ref={ref}
            {...props}
        />
    );
});

function titleCase(str) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
}

const customStyles = {
    control: (baseStyles) => ({
        ...baseStyles,
        fontSize: "12px",
        zIndex: 100,
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: "100px",
        overflowY: "scroll",
        zIndex: 100,
    }),
    option: (base) => ({
        ...base,
        fontSize: "12px",
        padding: "5px 10px",
        zIndex: 100,
    }),

    multiValue: (styles) => {
        return {
            ...styles,
            backgroundColor: "#dedeff",
            zIndex: 100,
        };
    },
    multiValueLabel: (styles) => ({
        ...styles,
        color: "#005eef",
        zIndex: 100,
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        color: "#005eef",
        ":hover": {
            backgroundColor: "#dedeff",
            color: "#005eef",
        },
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontSize: "12px",
        zIndex: 100,
    }),
};

function AutoDeckReportShare({ data = {}, open = false, handleCloseShareDialog = () => {}, fetchTableResult = () => {} }) {
    const selectRef = useRef(null);
    const dispatch = useDispatch();

    const userId = useSelector((state) => state.userStore.id);

    const [openManageAccess, setOpenManageAccess] = useState(false);
    const [minHeightDialog, setMinHeightDialog] = useState(DIALOG_HEIGHT);
    const [shareErrorDialog, setShareErrorDialog] = useState(false);
    const [shareErrorMessage, setShareErrorMessage] = useState(false);

    // users
    const [usersList, setUsersList] = useState([]);
    const [reportOwner, setReportOwner] = useState({});
    const [allUsersListApiRes, setAllUsersListApiRes] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [reportUsers, setReportUsers] = useState([]); // users have the access

    useEffect(() => {
        let controlHeight = 0;
        if (selectRef.current && selectedUsers.length) {
            controlHeight = selectRef?.current?.controlRef?.clientHeight - 35 || 0;
        }
        setMinHeightDialog(DIALOG_HEIGHT + controlHeight);
    }, [selectedUsers]);

    const handleClose = () => {
        reset();
        handleCloseShareDialog();
    };

    const handleShareErrorClose = () => {
        setShareErrorDialog(false);
        setShareErrorMessage("");
    };

    const handleManageAccessClickOpen = () => {
        setOpenManageAccess(true);
    };

    const handleManageAccessClose = () => {
        setOpenManageAccess(false);
    };

    const handleChange = (selected) => {
        setSelectedUsers(selected);
    };

    const handleRevokeAccess = async (e, data = {}) => {
        e.preventDefault();
        if (data?.accessId) {
            const url = process.env.REACT_APP_SERVER_PATH + `/auto-deck-report-shares/${data.accessId}/`;
            await api
                .delete(url)
                .then(async () => {
                    if (Number(data?.shared_with || 0) === Number(userId)) {
                        fetchTableResult();
                        handleClose();
                    } else {
                        const _users = reportUsers.filter((ele) => ele.user !== data.user);
                        setReportUsers([..._users]);
                    }
                    handleError("success", "Access Revoked");
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        }
    };

    const fetchUsersList = useCallback(async () => {
        const url = process.env.REACT_APP_SERVER_PATH + `/profiles/?archive=false&ordering=-id`;
        await api
            .get(url)
            .then(async (res) => {
                const _reportOwner = res.data.filter((ele) => ele.id === Number(data.created_by))?.[0] || {};
                setReportOwner(_reportOwner);
                const _resData = res.data
                    .filter((ele) => ele.id !== Number(data.created_by))
                    .map((ele) => {
                        return {
                            value: ele.value,
                            label: ele?.email || ele?.label || ele.user,
                        };
                    });
                setAllUsersListApiRes([..._resData]);
            })
            .catch(async (error) => {
                handleError("error", error);
            });
    }, [data]);

    const fetchReportAccessList = useCallback(async () => {
        const url = process.env.REACT_APP_SERVER_PATH + `/auto-deck-report-shares/?auto_deck_report=${data.id}`;
        await api
            .get(url)
            .then(async (res) => {
                const data = res.data.map((ele) => {
                    return {
                        accessId: ele.id,
                        shared_with: ele.shared_with,
                        user: ele.shared_with,
                        email: ele.shared_with__email,
                        shared_by_email: ele.shared_by__email,
                    };
                });
                setReportUsers([...data]);
                // setReportSharedListApiRes([...res.data]);
            })
            .catch(async (error) => {
                handleError("error", error);
            });
    }, [data]);

    useEffect(() => {
        if (open) {
            fetchUsersList();
            fetchReportAccessList();
        }
    }, [fetchUsersList, fetchReportAccessList, open]);

    useEffect(() => {
        const userIds = reportUsers.map((ele) => ele.shared_with); // exclude users from dropdown who already have an an access

        const _userList = allUsersListApiRes.filter((ele) => userIds.includes(ele.value) === false);
        setUsersList(_userList);
    }, [allUsersListApiRes, reportUsers]);

    const handleShareError = (error) => {
        const responseData = error.response?.data ?? {};
        if (Object.keys(responseData).length > 0 && responseData?.non_field_errors) {
            setShareErrorMessage(responseData?.non_field_errors?.[0] ?? "");
            setShareErrorDialog(true);
            handleClose();
        } else {
            handleError("error", error);
        }
    };

    const handleShare = async () => {
        const url = process.env.REACT_APP_SERVER_PATH + `/auto-deck-report-shares/`;

        const payloads = selectedUsers.map((ele) => {
            return {
                auto_deck_report: data.id,
                shared_with: ele.value,
                shared_by: userId,
            };
        });

        const requests = payloads.map((datum) => {
            return api.post(url, datum);
        });
        await api
            .all(requests)
            .then(() => {
                setSelectedUsers([]);
                fetchReportAccessList();
                handleError("success", "Report shared");
                handleClose();
            })
            .catch((error) => {
                handleShareError(error);
            });
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const manageAccessContainer = () => {
        return (
            <div>
                {reportOwner && renderUsersUnderManageAccess(reportOwner, 0, true)}
                {reportUsers.map((ele, i) => {
                    return renderUsersUnderManageAccess(ele, i);
                })}
            </div>
        );
    };

    const shareContainer = () => {
        return (
            <div>
                <Select
                    ref={selectRef}
                    styles={customStyles}
                    closeMenuOnSelect={false}
                    defaultMenuIsOpen={true}
                    value={selectedUsers}
                    onChange={handleChange}
                    placeholder="Search users ... "
                    isMulti
                    components={{
                        ...animatedComponents,
                        Option: CustomOption,
                        MultiValueLabel: CustomMultiValueLabel,
                        MultiValueRemove: CustomMultiValueRemove,
                    }}
                    options={usersList}
                />
            </div>
        );
    };

    const reset = () => {
        setSelectedUsers([]);
        setUsersList([]);
        setReportUsers([]);
        setOpenManageAccess(false);
    };

    const renderUsersUnderManageAccess = (ele, i, owner = false) => {
        return (
            <div
                key={i}
                style={{
                    display: "flex",
                    justifyItems: "center",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: "0px 0px 5px",
                    padding: "0px 0px 5px",
                    borderBottom: "1px solid rgb(123 131 141 / 22%)",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyItems: "center",
                        alignItems: "center",
                    }}
                >
                    <Avatar
                        key={i}
                        sx={{
                            bgcolor: stringToColor(ele.email),

                            width: 25,
                            height: 25,
                            fontSize: 10,
                            zIndex: i + 1,
                        }}
                    >
                        {getNameLetter(ele.email)}
                    </Avatar>
                    <div
                        style={{
                            marginLeft: "7px",
                        }}
                    >
                        <p
                            style={{
                                fontSize: "12px",
                                margin: 0,
                                color: "#005eef",
                            }}
                        >
                            {titleCase(ele.email.split("@")[0].replaceAll(".", " "))}
                        </p>
                        <p
                            style={{
                                fontSize: "10px",
                                margin: 0,
                            }}
                        >
                            {ele.email}
                        </p>
                    </div>
                </div>
                <div>
                    {owner ? (
                        <p
                            style={{
                                fontSize: "10px",
                                margin: 0,
                            }}
                        >
                            Owner
                        </p>
                    ) : (
                        <IconButton
                            aria-label="close"
                            sx={{
                                color: "rgb(51, 94, 234) !important",
                            }}
                            onClick={(e) => handleRevokeAccess(e, ele)}
                        >
                            <CloseIcon
                                style={{
                                    fontSize: 15,
                                }}
                            />
                        </IconButton>
                    )}
                </div>
            </div>
        );
    };
    return (
        <>
            {open && (
                <Dialog
                    open={open}
                    TransitionComponent={Transition}
                    keepMounted
                    maxWidth="sm"
                    fullWidth={true}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle
                        style={{
                            fontSize: "13px",
                        }}
                    >
                        {openManageAccess ? (
                            <>
                                <span
                                    style={{
                                        color: "#005eef",
                                        fontWeight: 700,
                                    }}
                                >
                                    Manage Access
                                </span>
                            </>
                        ) : (
                            <>
                                Share{" "}
                                <span
                                    style={{
                                        color: "#005eef",
                                        fontWeight: 700,
                                    }}
                                >
                                    {data.identifier}
                                </span>{" "}
                                with users
                            </>
                        )}
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 10,
                                top: 8,

                                color: "rgb(51, 94, 234) !important",
                            }}
                            onClick={handleClose}
                        >
                            <CloseIcon
                                style={{
                                    fontSize: 15,
                                }}
                            />
                        </IconButton>

                        <hr
                            style={{
                                margin: 0,
                            }}
                        />
                    </DialogTitle>
                    <DialogContent
                        style={
                            openManageAccess
                                ? { ...manageAccessContainerStyle }
                                : {
                                      minHeight: `${minHeightDialog}px`,
                                      maxHeight: "calc(100vh - 400px)",
                                  }
                        }
                    >
                        {openManageAccess && (
                            <IconButton
                                className="liner-light-blue-background color-white"
                                aria-label="close"
                                sx={{
                                    position: "absolute",
                                    // right: 10,
                                    top: 45,
                                    left: 17,
                                    padding: "2px",

                                    color: "rgb(51, 94, 234) !important",
                                }}
                                onClick={handleManageAccessClose}
                            >
                                <ArrowBackIcon
                                    style={{
                                        fontSize: 13,
                                    }}
                                    className="color-white"
                                />
                            </IconButton>
                        )}
                        {openManageAccess ? manageAccessContainer() : shareContainer()}
                    </DialogContent>
                    {!openManageAccess && (
                        <DialogActions
                            style={{
                                display: "flex",
                                justifyContent: "start",
                                margin: "0px 15px",
                                alignItems: "center",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    alignContent: "center",
                                    alignItems: "center",
                                    // border: '1px solid #eee',
                                    padding: "2px 5px",
                                    borderRadius: "5px",
                                    width: "100%",
                                }}
                            >
                                <AvatarGroup
                                    total={reportUsers.length}
                                    // spacing={"small"}
                                    sx={{
                                        "& .MuiAvatarGroup-avatar": {
                                            width: 25,
                                            height: 25,
                                            fontSize: 10,
                                        },
                                    }}
                                >
                                    {reportUsers
                                        ?.map((ele) => ele.email)
                                        .map((email, i) => {
                                            return (
                                                <Avatar
                                                    key={i}
                                                    sx={{
                                                        bgcolor: stringToColor(email),

                                                        width: 25,
                                                        height: 25,
                                                        fontSize: 10,
                                                        zIndex: i + 1,
                                                    }}
                                                >
                                                    {getNameLetter(email)}
                                                </Avatar>
                                            );
                                        })}
                                </AvatarGroup>
                                {reportUsers.length !== 0 && (
                                    <Avatar
                                        sx={{
                                            bgcolor: "white",
                                            border: "1px solid grey",
                                            width: 25,
                                            height: 25,
                                            cursor: "pointer",
                                        }}
                                        onClick={handleManageAccessClickOpen}
                                    >
                                        <MoreHorizIcon
                                            fontSize="20px"
                                            color="success"
                                        />
                                    </Avatar>
                                )}
                            </div>
                            <Button
                                size="small"
                                className="custom-btn"
                                variant="outlined"
                                color="primary"
                                disabled={selectedUsers.length === 0}
                                style={
                                    {
                                        // height: "38px",
                                        // fontSize: "12px"
                                    }
                                }
                                startIcon={<SendIcon />}
                                onClick={handleShare}
                            >
                                Share
                            </Button>
                        </DialogActions>
                    )}
                </Dialog>
            )}
            {shareErrorDialog && (
                <Dialog
                    open={shareErrorDialog}
                    TransitionComponent={Transition}
                    keepMounted
                    maxWidth="sm"
                    fullWidth={true}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle
                        style={{
                            fontSize: "13px",
                        }}
                    >
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 10,
                                top: 8,

                                color: "rgb(51, 94, 234) !important",
                            }}
                            onClick={handleShareErrorClose}
                        >
                            <CloseIcon
                                style={{
                                    fontSize: 15,
                                }}
                            />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <p style={{ padding: "20px 40px 0px 40px", textAlign: "center" }}>
                            {shareErrorMessage?.split(" ").map((word, index) =>
                                word.includes("@") ? (
                                    <span
                                        key={index}
                                        style={{ color: "#005EEF" }}
                                    >
                                        {word}{" "}
                                    </span>
                                ) : (
                                    `${word} `
                                )
                            )}
                        </p>
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
}

// Typechecking props for the AutoDeckReportShare
AutoDeckReportShare.propTypes = {
    data: PropTypes.object,
    open: PropTypes.bool,
    handleCloseShareDialog: PropTypes.func,
    fetchTableResult: PropTypes.func,
};

export default AutoDeckReportShare;
